export default function(_) {
  return typeof _ === 'boolean';
}



// WEBPACK FOOTER //
// ./~/vega-util/src/isBoolean.js